import { createFileRoute } from "@tanstack/react-router";

import { Fb4ClassicHomePage } from "@/components/Fb4ClassicHomePage";

const SITE_URL = "https://prank-reboot-studio.lovable.app";

export const Route = createFileRoute("/fb4")({
  head: () => ({
    meta: [
      { title: "Ross Creations — Exclusive Prank Videos" },
      {
        name: "description",
        content:
          "Subscribe to premium RossCreations videos and get unlimited access to video releases.",
      },
      { property: "og:title", content: "Explore Exclusive Prank Videos On Ross Creations" },
      {
        property: "og:description",
        content:
          "Subscribe to premium RossCreations videos and get unlimited access to video releases.",
      },
      { property: "og:url", content: `${SITE_URL}/fb4` },
      { property: "og:image", content: `${SITE_URL}/og-image.png` },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: `${SITE_URL}/og-image.png` },
    ],
    links: [
      { rel: "canonical", href: `${SITE_URL}/fb4` },
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&display=swap",
      },
    ],
  }),
  component: Fb4Page,
});

function Fb4Page() {
  return <Fb4ClassicHomePage />;
}
